import type { Context, ReactNode, JSX } from 'react';
// local imports
import { IDataState } from './dataContext';
import { DataContext as DataContextUntyped, DataProvider as DataProviderUntyped } from './data';

export const DataContext = DataContextUntyped as unknown as Context<IDataState>;
export const DataProvider = DataProviderUntyped as unknown as ({ children, state }: {
  children: ReactNode;
  state?: IDataState;
}) => JSX.Element;
